import axiosInstance from '../config/axiosConfig';

export const fetchNotifications = async (userId: string) => {
  if (!userId) return [];
  try {
    const response = await axiosInstance.get(`/notifications/${userId}`);
    return response.data.result || [];
  } catch (error) {
    console.error('Error fetching notifications', error);
    return [];
  }
};
export const markAllAsReadNotifications = async (userId: string) => {
  if (!userId) return;

  try {
    const response = await axiosInstance.post(
      `/notifications/${userId}/markAsRead`,
    );

    return response.data.result;
  } catch (error) {
    console.error('Error marking notifications as read', error);
  }
};
export const markSingleNotificationAsRead = async (notificationId: string) => {
  if (!notificationId) return [];
  try {
    const response = await axiosInstance.post(
      `/notifications/${notificationId}/markSingleAsRead`,
    );
    return response.data.result || [];
  } catch (error) {
    console.error('Error fetching notifications', error);
    return [];
  }
};
